// extracted by mini-css-extract-plugin
module.exports = {"component":"VehicleSelector_component__yFBw7"};